import React from 'react';
import { LucideIcon } from 'lucide-react';

interface IconProps {
  icon: LucideIcon;
  size?: number;
  strokeWidth?: number;
  color?: string;
  className?: string;
}

/**
 * Icon Wrapper Component - Premium thin-line icon styling
 * - Consistent stroke width (default 1.5)
 * - Rounded linecaps
 * - Monochrome color
 * - Supports CSS variables for theming
 */
export const Icon: React.FC<IconProps> = ({
  icon: IconComponent,
  size = 24,
  strokeWidth = 1.5,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <IconComponent
      size={size}
      strokeWidth={strokeWidth}
      color={color}
      className={className}
      style={{
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }}
    />
  );
};

export default Icon;





























